import { ISeriesPrototype } from '@/types/series.types';
import { Get } from '../helpers';
import { SeriesPath } from './path';

export default function LoadSeriesListForChannel({
  channel,
  page,
  limit,
  withEvents,
  search,
}: {
  channel: number;
  page?: number;
  limit?: number;
  withEvents?: boolean;
  search?: string;
}) {
  const params = new URLSearchParams({ page: String(page ?? 1), limit: String(limit ?? 1000) });
  if (withEvents) {
    params.set('full', 'true');
  }
  if (search) {
    params.set('search', search);
  }
  return Get<{ series: ISeriesPrototype[]; total: number }>({
    path: SeriesPath(channel, `?${params.toString()}`),
  });
}
